// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coordinator-auth {
    --form-width: 100%;
    --card-padding: 20px;
    --form-wrapper-h-padding: 30px;
    --ce-base-padding-small: 10px;
    --ce-base-padding-default: 12px;
    --ce-base-padding-large: 20px;
    --ce-base-padding-v: var(--ce-base-padding-default);
    --ce-base-padding-h: var(--ce-base-padding-small);
    --ce-border-radius-small: 4px;
    --ce-border-radius-default: 6px;
    --ce-border-radius-large: 10px;
    --ce-interactable-padding-small: 8px;
    --ce-interactable-padding-default: var(--ce-base-padding-default);
    --ce-interactable-padding-large: 16px;
    --ce-font-family-body: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    font-size: 16px;
    line-height: var(--default_line_height);
}

.coordinator-auth h2 {
    font-size: 30px;
    font-weight: 600;
    padding-bottom: 0;
    line-height: 1.2;
    margin-bottom: 3px;
}

.coordinator-auth h3 {
    font-size: 20px;
    color: var(--lightest_legible_grey);
    font-weight: 500;
}

.coordinator-auth p,
.coordinator-auth li {
    padding: 4px 0;
}

.coordinator-auth ol,
.coordinator-auth ul {
    list-style: disc;
    padding-left: 1.25em;
}

.coordinator-auth main {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    flex-direction: column;
}

.coordinator-auth .form-wrapper {
    padding: 35px var(--form-wrapper-h-padding) 40px var(--form-wrapper-h-padding);
    background: var(--ce-grey-1);
    width: 100%;
    flex: 1;
}

.coordinator-auth .form {
    margin: 0 auto;
    width: var(--form-width);
    display: flex;
    flex-direction: column;
    row-gap: var(--md_padding);
    align-items: stretch;
    max-width: 100%;
}

.coordinator-auth .form-header {
    text-align: center;
    margin-bottom: var(--sm_padding);
    flex-direction: column;
    display: flex;
    align-items: center;
    justify-content: center;
}

.coordinator-auth .form-header-logo {
    margin-bottom: 20px;
    max-width: 150px;
}

.coordinator-auth input,
.coordinator-auth button,
.coordinator-auth .admin-input,
.coordinator-auth .editor-controls-button {
    height: var(--ideal_touch_target);
    min-height: var(--ideal_touch_target);
    min-width: var(--ideal_touch_target);
    font-size: 16px;
}

.coordinator-auth .editor-controls-button {
    font-weight: 500;
}

.coordinator-auth .field-group {
    display: flex;
    flex-direction: column;
}

.coordinator-auth .field-group label {
    font-weight: 500;
    padding-bottom: 3px;
}

.coordinator-auth .editor-controls-button.text-button {
    background: transparent;
    border: 0;
    text-decoration: none;
    font-weight: 500;
    display: flex;
    align-items: center;
    color: var(--blue);
}

.coordinator-auth .editor-controls-button.text-button:hover,
.coordinator-auth .editor-controls-button.text-button:hover:enabled {
    color: var(--ce-blue-70);
    background: transparent;
}

.coordinator-auth .editor-controls-button.tertiary-button {
    background: var(--ce-grey-4);
    color: var(--ce-blue-50);
    border: 0;
    text-decoration: none;
    font-weight: 500;
    align-items: center;
    display: flex;
}

.coordinator-auth .server-error {
    color: var(--ce-red-55);
    background: var(--ce-red-2);
    border: 1px solid var(--ce-red-10);
    border-radius: var(--border_radius);
    padding: 8px 12px;
}

.coordinator-auth .client-error-container {
    background: var(--ce-violet-2);
    border: 1px solid var(--ce-violet-10);
    margin-bottom: 2rem;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 12px;
    border-radius: var(--border_radius);
}
`, "",{"version":3,"sources":["webpack://./src/components/Authentication/Coordinator/shared.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,8BAA8B;IAC9B,6BAA6B;IAC7B,+BAA+B;IAC/B,6BAA6B;IAC7B,mDAAmD;IACnD,iDAAiD;IACjD,6BAA6B;IAC7B,+BAA+B;IAC/B,8BAA8B;IAC9B,oCAAoC;IACpC,iEAAiE;IACjE,qCAAqC;IACrC,oKAAoK;IACpK,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mCAAmC;IACnC,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,8EAA8E;IAC9E,4BAA4B;IAC5B,WAAW;IACX,OAAO;AACX;;AAEA;IACI,cAAc;IACd,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;;;IAII,iCAAiC;IACjC,qCAAqC;IACrC,oCAAoC;IACpC,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;IACI,4BAA4B;IAC5B,wBAAwB;IACxB,SAAS;IACT,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,kCAAkC;IAClC,mCAAmC;IACnC,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,qCAAqC;IACrC,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,mCAAmC;AACvC","sourcesContent":[".coordinator-auth {\n    --form-width: 100%;\n    --card-padding: 20px;\n    --form-wrapper-h-padding: 30px;\n    --ce-base-padding-small: 10px;\n    --ce-base-padding-default: 12px;\n    --ce-base-padding-large: 20px;\n    --ce-base-padding-v: var(--ce-base-padding-default);\n    --ce-base-padding-h: var(--ce-base-padding-small);\n    --ce-border-radius-small: 4px;\n    --ce-border-radius-default: 6px;\n    --ce-border-radius-large: 10px;\n    --ce-interactable-padding-small: 8px;\n    --ce-interactable-padding-default: var(--ce-base-padding-default);\n    --ce-interactable-padding-large: 16px;\n    --ce-font-family-body: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n    font-size: 16px;\n    line-height: var(--default_line_height);\n}\n\n.coordinator-auth h2 {\n    font-size: 30px;\n    font-weight: 600;\n    padding-bottom: 0;\n    line-height: 1.2;\n    margin-bottom: 3px;\n}\n\n.coordinator-auth h3 {\n    font-size: 20px;\n    color: var(--lightest_legible_grey);\n    font-weight: 500;\n}\n\n.coordinator-auth p,\n.coordinator-auth li {\n    padding: 4px 0;\n}\n\n.coordinator-auth ol,\n.coordinator-auth ul {\n    list-style: disc;\n    padding-left: 1.25em;\n}\n\n.coordinator-auth main {\n    position: relative;\n    flex: 1;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n}\n\n.coordinator-auth .form-wrapper {\n    padding: 35px var(--form-wrapper-h-padding) 40px var(--form-wrapper-h-padding);\n    background: var(--ce-grey-1);\n    width: 100%;\n    flex: 1;\n}\n\n.coordinator-auth .form {\n    margin: 0 auto;\n    width: var(--form-width);\n    display: flex;\n    flex-direction: column;\n    row-gap: var(--md_padding);\n    align-items: stretch;\n    max-width: 100%;\n}\n\n.coordinator-auth .form-header {\n    text-align: center;\n    margin-bottom: var(--sm_padding);\n    flex-direction: column;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.coordinator-auth .form-header-logo {\n    margin-bottom: 20px;\n    max-width: 150px;\n}\n\n.coordinator-auth input,\n.coordinator-auth button,\n.coordinator-auth .admin-input,\n.coordinator-auth .editor-controls-button {\n    height: var(--ideal_touch_target);\n    min-height: var(--ideal_touch_target);\n    min-width: var(--ideal_touch_target);\n    font-size: 16px;\n}\n\n.coordinator-auth .editor-controls-button {\n    font-weight: 500;\n}\n\n.coordinator-auth .field-group {\n    display: flex;\n    flex-direction: column;\n}\n\n.coordinator-auth .field-group label {\n    font-weight: 500;\n    padding-bottom: 3px;\n}\n\n.coordinator-auth .editor-controls-button.text-button {\n    background: transparent;\n    border: 0;\n    text-decoration: none;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    color: var(--blue);\n}\n\n.coordinator-auth .editor-controls-button.text-button:hover,\n.coordinator-auth .editor-controls-button.text-button:hover:enabled {\n    color: var(--ce-blue-70);\n    background: transparent;\n}\n\n.coordinator-auth .editor-controls-button.tertiary-button {\n    background: var(--ce-grey-4);\n    color: var(--ce-blue-50);\n    border: 0;\n    text-decoration: none;\n    font-weight: 500;\n    align-items: center;\n    display: flex;\n}\n\n.coordinator-auth .server-error {\n    color: var(--ce-red-55);\n    background: var(--ce-red-2);\n    border: 1px solid var(--ce-red-10);\n    border-radius: var(--border_radius);\n    padding: 8px 12px;\n}\n\n.coordinator-auth .client-error-container {\n    background: var(--ce-violet-2);\n    border: 1px solid var(--ce-violet-10);\n    margin-bottom: 2rem;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding: 12px;\n    border-radius: var(--border_radius);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
